/**
 * Layer 1 typo-suggestion for the taker SPA.
 *
 * MIRROR — keep DOMAIN_TYPOS in sync with worker/src/email-validator.ts and
 * embed/src/email-validator.ts. The dictionary lives canonically in the worker
 * module; copy here to avoid bundling worker code into the taker.
 */

export const DOMAIN_TYPOS: Record<string, string> = {
  'gmai.com': 'gmail.com',
  'gmial.com': 'gmail.com',
  'gmaill.com': 'gmail.com',
  'gmali.com': 'gmail.com',
  'gnail.com': 'gmail.com',
  'gmail.co': 'gmail.com',
  'gmail.con': 'gmail.com',
  'gmail.cm': 'gmail.com',
  'gmail.comm': 'gmail.com',
  'gmail.om': 'gmail.com',
  'gmail.net': 'gmail.com',
  'gmail.ca': 'gmail.com',
  'gnail.con': 'gmail.com',
  'yahooo.com': 'yahoo.com',
  'yahoo.con': 'yahoo.com',
  'yahoo.co': 'yahoo.com',
  'yahoo.cm': 'yahoo.com',
  'yhoo.com': 'yahoo.com',
  'yaho.com': 'yahoo.com',
  'yahho.com': 'yahoo.com',
  'yahoocom': 'yahoo.com',
  'hotmial.com': 'hotmail.com',
  'hotmai.com': 'hotmail.com',
  'hotmail.con': 'hotmail.com',
  'hotmail.co': 'hotmail.com',
  'hotmail.cm': 'hotmail.com',
  'hotmial.co': 'hotmail.com',
  'hottmail.com': 'hotmail.com',
  'hotnail.com': 'hotmail.com',
  'outlok.com': 'outlook.com',
  'outloo.com': 'outlook.com',
  'outlook.con': 'outlook.com',
  'outlook.co': 'outlook.com',
  'outlook.cm': 'outlook.com',
  'outllok.com': 'outlook.com',
  'iclod.com': 'icloud.com',
  'icoud.com': 'icloud.com',
  'icloud.con': 'icloud.com',
  'icloud.co': 'icloud.com',
  'icloud.cm': 'icloud.com',
  'iclooud.com': 'icloud.com',
  'aol.con': 'aol.com',
  'aol.co': 'aol.com',
  'aol.cm': 'aol.com',
  'aoll.com': 'aol.com',
  'live.con': 'live.com',
  'live.co': 'live.com',
  'me.con': 'me.com',
  'me.co': 'me.com',
  'comcast.com': 'comcast.net',
  'comcast.con': 'comcast.net',
  'bigpond.com': 'bigpond.net.au',
};

export function suggestTypoCorrection(email: string): string | null {
  const at = email.lastIndexOf('@');
  if (at < 1 || at === email.length - 1) return null;
  const local = email.slice(0, at);
  const domain = email.slice(at + 1).toLowerCase().trim();
  const corrected = DOMAIN_TYPOS[domain];
  if (!corrected) return null;
  return `${local}@${corrected}`;
}
